/**
 * @auctogon/ui/brand — Auctogon brand artwork.
 *
 * Pure data: viewBoxes and path strings, no React and no DOM. That contract is
 * what lets `apps/admin-catalog` (React Native) import the same geometry the web
 * apps use, and it is pinned by `__tests__/brand-rn-safe.test.ts`.
 *
 * Rendering lives in per-platform skins, not here — `AuctogonLogo` from
 * `@auctogon/ui/web` for the DOM, and the react-native-svg twin in the catalog
 * app. Both do nothing but map `paths` onto their platform's path element
 * (ADR 030 Decision 2: shared core, thin skins).
 *
 * NOT re-exported from the package root barrel — see `src/index.ts`.
 */
export type { BrandArtwork } from './logo-geometry';
export {
    AUCTOGON_MARK,
    AUCTOGON_WORDMARK,
    AUCTOGON_LOCKUP,
    AUCTOGON_LOCKUP_PROPORTIONS,
} from './logo-geometry';
